import React, { useState } from "react";
import styled from "styled-components";
import { Person, List } from "react-bootstrap-icons";
import { Box, Stack, IconButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import appRoutes from "app/config/routes";
import MobileInstituteBrand from "../Header/components/MobileInstituteBrand";
import UserProfileDrawer from "../Header/components/UserProfileDrawer";
import HomeIcon from "@mui/icons-material/Home";

const MobileHeader = ({ setShow }) => {
  const { pathname } = useLocation();
  const [state, setState] = useState({
    showSidebar: false,
  });
  const navigate = useNavigate();

  return (
    <>
      <UserProfileDrawer state={state} setState={setState} />
      <StyledContainer>
        <Box className="header-wrapper">
          <Stack 
            direction="row" 
            alignItems="center" 
            justifyContent="space-between"
            px={1}
            py={1.5}
          >
            {/* Left Section - Menu */}
            <IconButton
              onClick={() => setShow(true)}
              className="icon-button"
              size="small"
            >
              <List size={24} color="#fff" />
            </IconButton>

            {/* Center Section - Brand */}
            {pathname !== appRoutes.schools && (
              <Box className="brand-container">
                <MobileInstituteBrand />
              </Box>
            )}

            {/* Right Section - Actions */}
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                onClick={() => navigate("/dashboard")}
                className="icon-button"
                size="small"
              >
                <HomeIcon sx={{ fontSize: 22, color: "#fff" }} />
              </IconButton>

              <IconButton
                onClick={() =>
                  setState((prev) => ({ ...prev, showSidebar: true }))
                }
                className="icon-button"
                size="small"
              >
                <Person size={22} color="#fff" />
              </IconButton>
            </Stack>
          </Stack>
        </Box>
      </StyledContainer>
    </>
  );
};

export default MobileHeader;

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #084c84;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .header-wrapper {
    background: linear-gradient(135deg, #084c84 0%, #0a5a9a 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .brand-container {
    position: absolute;
    left: 42.5%;
    transform: translateX(-50%);
    max-width: 60%;
    
    /* Ensure text truncation if too long */
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-button {
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
    background: rgba(255, 255, 255, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }
`;